export type ChargerVehicleQualificationInputs = {
  modelNumber?: string;
  modelNumberImage?: { id?: string };
  vehicleManufacturer?: string;
  vehicleModel?: string;
};

// Note: Only keep the old enrollment preference if nothing that could change qualification actually changed.
export const haveChargerOrVehicleInputsChanged = (
  formValues: ChargerVehicleQualificationInputs,
  baseline?: ChargerVehicleQualificationInputs,
): boolean =>
  formValues.modelNumber !== baseline?.modelNumber ||
  formValues.modelNumberImage?.id !== baseline?.modelNumberImage?.id ||
  formValues.vehicleManufacturer !== baseline?.vehicleManufacturer ||
  formValues.vehicleModel !== baseline?.vehicleModel;

export type VinQualificationInputs = {
  vin?: string;
  vinImage?: { id?: string };
};

// Note: Only counts as "changed" on a real VIN replacement (baseline already had one).. not a first-time upload
export const hasVinInputChanged = (
  formValues: VinQualificationInputs,
  baseline?: VinQualificationInputs,
): boolean => Boolean(baseline?.vin) && formValues.vin !== baseline?.vin;
